/**
 * DRF (Debt Retirement Fund) debug field definitions
 */

import type { DebugFieldDefinition } from '../types';
import { formatCurrency } from './formatters';

export const drfFields: DebugFieldDefinition[] = [
  {
    id: 'drf.starting',
    name: 'DRF Starting Balance',
    category: 'drf',
    description: 'DRF balance at the start of this payment period',
    extractor: (ctx) => ctx.cashFlow?.drfStartingBalance,
    formatter: formatCurrency,
    performanceCost: 'low',
    enabledByDefault: true,
  },
  {
    id: 'drf.ending',
    name: 'DRF Ending Balance',
    category: 'drf',
    description: 'DRF balance at the end of this payment period',
    extractor: (ctx) => ctx.cashFlow?.drfEndingBalance,
    formatter: formatCurrency,
    performanceCost: 'low',
    enabledByDefault: true,
  },
  {
    id: 'drf.adjustment',
    name: 'DRF Adjustment',
    category: 'drf',
    description: 'DRF adjustment applied this period',
    extractor: (ctx) => ctx.cashFlow?.drfAdjustment,
    formatter: formatCurrency,
    performanceCost: 'low',
    enabledByDefault: true,
  },
  {
    id: 'drf.netChange',
    name: 'DRF Net Change',
    category: 'drf',
    description: 'Net change in DRF balance this period',
    extractor: (ctx) => ctx.cashFlow?.drfNetChange,
    formatter: formatCurrency,
    formula: (ctx) => {
      const cf = ctx.cashFlow;
      if (!cf) return undefined;
      return `Ending ($${cf.drfEndingBalance?.toLocaleString()}) - Starting ($${cf.drfStartingBalance?.toLocaleString()}) = $${cf.drfNetChange?.toLocaleString()}`;
    },
    performanceCost: 'low',
    enabledByDefault: true,
  },
  {
    id: 'drf.netRevenue',
    name: 'DRF Net Revenue',
    category: 'drf',
    description: 'Revenue after DRF adjustment',
    extractor: (ctx) => ctx.cashFlow?.drfNetRevenue,
    formatter: formatCurrency,
    performanceCost: 'low',
    enabledByDefault: false,
  },
];
